import React, { useState, useCallback, useMemo } from 'react';
import { useQuery } from 'react-query';
import { Typography, CircularProgress, Box, Button } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import { FileDownload } from '@omega-energia/react';
import { useAuth } from '../../../../auth/authProvider';
import request from '../../../../services/network/request';
import { ContestComissionTable } from './ContestComissionTable/ContestComissionTable';

const ContestComission = () => {
  const { token } = useAuth();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sorts, setSorts] = useState({ createdAt: 'DESC' });

  const parseValues = useCallback(obj => {
    return Object.entries(obj)
      .filter(([, value]) => value)
      .map(([key, value]) => `${key}:${value}`)
      .join(',');
  }, []);

  const queryParams = useMemo(
    () => ({
      sort: parseValues(sorts),
      page: currentPage,
      take: rowsPerPage,
    }),
    [parseValues, sorts, currentPage, rowsPerPage],
  );

  const { data, isFetching: isLoading } = useQuery(
    ['fetch-contest-comission', currentPage, rowsPerPage, sorts],
    () => request.get('backstage/comunidade/contest-comission', { token, params: queryParams }),
    {
      keepPreviousData: true,
      staleTime: 30000,
    },
  );

  const tableData = data?.data || [];
  const total = data?.pagination?.totalRecords || 0;

  const handleChangePage = useCallback((_, newPage) => {
    setCurrentPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback(event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  }, []);

  const handleDownload = useCallback(async () => {
    const params = {
      sort: parseValues(sorts),
    };

    const file = await request.get('backstage/comunidade/contest-comission/download', {
      token,
      params,
      responseType: 'arrayBuffer',
    });

    const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), file], { type: 'text/csv' });

    FileDownload.downloadFile(blob, 'contestacoes-comissionamento');
  }, [token, sorts, parseValues]);

  return (
    <>
      {!isLoading && (
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Button color="primary" onClick={handleDownload} variant="contained" startIcon={<GetApp />}>
            Baixar Planilha
          </Button>
        </Box>
      )}

      {isLoading && (
        <Box display="flex" justifyContent="center" my={4}>
          <CircularProgress />
        </Box>
      )}

      {!isLoading && tableData.length > 0 && (
        <ContestComissionTable
          data={tableData}
          setSorts={setSorts}
          sorts={sorts}
          total={total}
          rowsPerPage={rowsPerPage}
          currentPage={currentPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}

      {!isLoading && tableData.length === 0 && (
        <Typography align="center" variant="body1" color="textSecondary" style={{ marginTop: 24 }}>
          Ops. Não encontramos nada.
        </Typography>
      )}
    </>
  );
};

export { ContestComission };
